(()=>{if(customElements.get("jacc-compact-header"))return;class JaccCompactHeader extends HTMLElement{connectedCallback(){this.header=this.querySelector("x-header"),this.section=this.closest(".shopify-section--header"),this.navigation=this.querySelector(".header__primary-nav"),this.utilities=this.querySelector(".header__secondary-nav"),!(!this.header||!this.section)&&(this.abortController=new AbortController,this.schedule=()=>{this.frame||(this.frame=requestAnimationFrame(()=>{this.frame=null,this.updateVisibleHeight()}))},this.measure=()=>{const headerTop=this.header.getBoundingClientRect().top,rowTops=[this.navigation,this.utilities].filter(element=>element&&element.getClientRects().length).map(element=>element.getBoundingClientRect().top-headerTop),mastheadHeight=rowTops.length?Math.max(0,Math.min(...rowTops)):0;this.section.style.setProperty("--jacc-masthead-height",`${mastheadHeight.toFixed(2)}px`),this.updateVisibleHeight()},this.resizeObserver=new ResizeObserver(this.measure),[this.header,this.navigation,this.utilities].filter(Boolean).forEach(element=>this.resizeObserver.observe(element)),window.addEventListener("scroll",this.schedule,{passive:!0,signal:this.abortController.signal}),window.addEventListener("resize",this.measure,{passive:!0,signal:this.abortController.signal}),document.documentElement.style.setProperty("--header-is-visible","1"),this.measure(),document.fonts?.ready.then(()=>{this.isConnected&&this.measure()}))}updateVisibleHeight(){const rect=this.header.getBoundingClientRect(),visibleHeight=this.dataset.sticky==="true"?Math.max(0,rect.bottom-Math.max(0,rect.top)):rect.height;document.documentElement.style.setProperty("--header-height",`${visibleHeight.toFixed(2)}px`)}disconnectedCallback(){this.abortController?.abort(),this.resizeObserver?.disconnect(),this.frame&&cancelAnimationFrame(this.frame),this.frame=null}}customElements.define("jacc-compact-header",JaccCompactHeader)})();

/* Group the existing Prestige mobile brand menu without changing Shopify menu data. */
(() => {
  const brandNames = [
    'Anton Schneider', 'Comitti of London', 'Hermle', 'Hönes',
    'Howard Miller', 'Kieninger', 'NeXtime', 'Rombach & Haas',
    'Sternreiter', 'Weems & Plath'
  ];

  function groupMobileBrands() {
    const sidebar = document.getElementById('sidebar-menu');
    if (!sidebar || sidebar.dataset.jaccBrandsGrouped === 'true') return;

    const mainList = sidebar.querySelector('.header-sidebar__main-panel .header-sidebar__linklist');
    if (!mainList) return;

    const rootRows = Array.from(mainList.children);
    const brandRows = rootRows.slice(2, 12);
    const titles = brandRows.map(row => row.querySelector('button')?.textContent.trim().replace(/\s+/g, ' '));
    if (titles.some((title, index) => title !== brandNames[index])) return;

    const panels = brandRows.map(row => {
      const id = row.querySelector('button')?.getAttribute('aria-controls');
      return id ? sidebar.querySelector(`#${CSS.escape(id)}`) : null;
    });
    const panelLinks = panels.map(panel => panel?.querySelectorAll(':scope > .header-sidebar__linklist > li > a'));
    if (panelLinks.some(links => !links?.length || Array.from(links).some(link => !link.getAttribute('href')))) return;

    const firstPanel = panels[0];
    const firstButton = brandRows[0].querySelector('button');
    const backButton = firstPanel.querySelector('.header-sidebar__back-button');
    const firstList = firstPanel.querySelector('.header-sidebar__linklist');
    if (!firstButton || !backButton || !firstList) return;
    const buttonLabel = Array.from(firstButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
    const backLabel = Array.from(backButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
    if (!buttonLabel || !backLabel) return;

    // Assemble the replacement first, so a changed menu layout leaves the live drawer alone.
    const groupedList = document.createDocumentFragment();
    brandNames.forEach((brandName, index) => {
      const item = document.createElement('li');
      const disclosure = document.createElement('accordion-disclosure');
      const details = document.createElement('details');
      details.className = 'accordion__disclosure group';

      const summary = document.createElement('summary');
      summary.className = 'header-sidebar__linklist-button';
      summary.append(document.createTextNode(brandName));
      const plus = document.createElement('span');
      plus.className = 'animated-plus group-expanded:rotate';
      plus.setAttribute('aria-hidden', 'true');
      summary.append(plus);

      const childLinks = document.createElement('div');
      childLinks.className = 'header-sidebar__nested-linklist';
      panelLinks[index].forEach(link => {
        const clone = link.cloneNode(true);
        clone.className = 'link-faded-reverse';
        childLinks.append(clone);
      });

      details.append(summary, childLinks);
      disclosure.append(details);
      item.append(disclosure);
      groupedList.append(item);
    });

    // Reuse the existing Anton Schneider button/panel so Prestige's drawer controls stay wired.
    buttonLabel.textContent = 'Our Brands';
    backLabel.textContent = 'Our Brands';
    firstList.replaceChildren(groupedList);
    brandRows.slice(1).forEach(row => row.remove());
    // Leave the other hidden panels in place: Prestige may have cached them on startup.
    sidebar.dataset.jaccBrandsGrouped = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupMobileBrands, { once: true });
  } else {
    groupMobileBrands();
  }
  document.addEventListener('shopify:section:load', groupMobileBrands);
})();
/*
 * JACC desktop header: show Ready to Ship beside View All Clocks.
 * Included in this full replacement for assets/jacc-compact-header.js.
 * Links directly to the master Ready to Ship collection.
 */
(() => {
  if (window.jaccShopByBrandShortcutInstalled) return;
  window.jaccShopByBrandShortcutInstalled = true;

  const style = document.createElement('style');
  style.id = 'jacc-shop-by-brand-shortcut-style';
  style.textContent = `
    @media (min-width: 1150px) {
      .jacc-gallery .jacc-compact-header .header__primary-nav-item > dropdown-menu-disclosure > details > summary:is([data-title="Shop All Clocks"], [data-title="Shop Clocks"]) + ul.header__dropdown-menu.jacc-has-brand-switch > li:first-child {
        grid-column: auto;
      }

      /* Keep the two special shopping paths together as the first visual row. */
      .jacc-gallery .jacc-compact-header .header__dropdown-menu.jacc-has-brand-switch > li.jacc-ready-shortcut { order: -2; }
      .jacc-gallery .jacc-compact-header .header__dropdown-menu.jacc-has-brand-switch > li.jacc-style-shortcut { order: -1; }

      .jacc-gallery .jacc-compact-header .header__primary-nav-item > dropdown-menu-disclosure > details > ul.header__dropdown-menu > li.jacc-brand-switch-item > a.jacc-brand-switch {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        width: 100%;
        min-height: 48px;
        padding: 8px 0;
        border: 0;
        border-radius: 0;
        background: transparent;
        color: var(--jacc-ink);
        font: 500 21px/1.2 var(--jacc-serif);
        letter-spacing: 0;
        text-align: left;
        white-space: normal;
        cursor: pointer;
        text-decoration: none;
      }

      .jacc-gallery .jacc-compact-header .jacc-brand-switch > span {
        flex: none;
        margin-left: 2px;
        color: #92713e;
        font: 400 21px/1 Georgia, serif;
      }

      .jacc-gallery .jacc-compact-header .header__primary-nav-item > dropdown-menu-disclosure > details > ul.header__dropdown-menu > li.jacc-brand-switch-item > a.jacc-brand-switch:hover {
        color: #826637;
      }

      .jacc-gallery .jacc-compact-header .header__primary-nav-item > dropdown-menu-disclosure > details > ul.header__dropdown-menu > li.jacc-brand-switch-item > a.jacc-brand-switch:focus-visible {
        outline: 2px solid var(--jacc-gold);
        outline-offset: 2px;
      }
    }

    @media (max-width: 1149px) {
      .jacc-mobile-brand-shortcut {
        display: inline-flex !important;
        align-items: center;
        justify-content: flex-start !important;
        gap: 8px;
      }
      .jacc-mobile-brand-shortcut > span {
        margin-left: 2px;
      }
    }
  `;
  document.head.append(style);

  function installBrandShortcut() {
    document.querySelectorAll('jacc-compact-header').forEach(header => {
      const shopSummary = header.querySelector('.header__primary-nav summary[data-title="Shop All Clocks"], .header__primary-nav summary[data-title="Shop Clocks"]');
      const shopDisclosure = shopSummary?.closest('dropdown-menu-disclosure');
      const shopDetails = shopDisclosure?.querySelector(':scope > details');
      const shopMenu = shopDetails?.querySelector(':scope > ul.header__dropdown-menu');

      // Only touch the current desktop menu once Prestige has upgraded its components.
      if (!shopMenu || shopMenu.querySelector('.jacc-brand-switch-item') ||
          shopMenu.firstElementChild?.querySelector(':scope > a')?.textContent.trim() !== 'View All Clocks') return;

      const shortcuts = [
        { label: 'Ready to Ship', href: '/collections/ready-to-ship-clocks' },
        { label: 'Shop by Style', href: '/collections?view=styles' }
      ];
      const firstStandardItem = shopMenu.firstElementChild;

      shortcuts.forEach(({ label, href }) => {
        const row = document.createElement('li');
        row.className = 'jacc-brand-switch-item ' + (label === 'Ready to Ship' ? 'jacc-ready-shortcut' : 'jacc-style-shortcut');
        const link = document.createElement('a');
        link.href = href;
        link.className = 'jacc-brand-switch';
        link.append(document.createTextNode(label));
        const arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.append(arrow);
        row.append(link);
        shopMenu.insertBefore(row, firstStandardItem);
      });

      shopMenu.classList.add('jacc-has-brand-switch');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installBrandShortcut, { once: true });
  } else {
    installBrandShortcut();
  }
  document.addEventListener('shopify:section:load', installBrandShortcut);
})();

/* Mobile: add Ready to Ship directly beneath View All Clocks. */
(() => {
  if (window.jaccMobileBrandShortcutInstalled) return;
  window.jaccMobileBrandShortcutInstalled = true;

  function installMobileBrandShortcut() {
    const sidebar = document.getElementById('sidebar-menu');
    if (!sidebar || sidebar.dataset.jaccBrandsGrouped !== 'true') return;

    const rootList = sidebar.querySelector('.header-sidebar__main-panel .header-sidebar__linklist');
    const shopButton = rootList?.children[1]?.querySelector('button[aria-controls]');
    const shopId = shopButton?.getAttribute('aria-controls');
    const shopPanel = shopId && document.getElementById(shopId);
    const shopList = shopPanel?.querySelector(':scope > ul.header-sidebar__linklist');

    if (!shopPanel || !shopList ||
        shopList.querySelector('.jacc-mobile-brand-shortcut') ||
        shopButton?.textContent.trim() !== 'Shop All Clocks' ||
        shopList.firstElementChild?.querySelector(':scope > a')?.textContent.trim() !== 'View All Clocks') return;

    const shortcuts = [
      { label: 'Ready to Ship', href: '/collections/ready-to-ship-clocks' },
      { label: 'Shop by Style', href: '/collections?view=styles' }
    ];
    let insertAfter = shopList.firstElementChild;

    shortcuts.forEach(({ label, href }) => {
      const row = document.createElement('li');
      const shortcut = document.createElement('a');
      shortcut.href = href;
      shortcut.className = 'header-sidebar__linklist-button jacc-mobile-brand-shortcut';
      shortcut.append(document.createTextNode(label));
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      shortcut.append(arrow);
      row.append(shortcut);
      insertAfter.after(row);
      insertAfter = row;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installMobileBrandShortcut, { once: true });
  } else {
    installMobileBrandShortcut();
  }
  document.addEventListener('shopify:section:load', installMobileBrandShortcut);
})();
/*
 * JACC desktop Our Brands: one expanded brand at a time.
 *
 * BACKUP THEME: Assets > jacc-compact-header.js
 * Scroll to the very bottom and PASTE this entire block after the existing code.
 * Do not replace the existing script. No CSS or mobile menu changes are needed.
 */
(() => {
  function installExclusiveBrands() {
    document.querySelectorAll('jacc-compact-header .jacc-brands-grid').forEach(grid => {
      if (grid.dataset.jaccExclusiveBrands === 'true') return;
      grid.dataset.jaccExclusiveBrands = 'true';

      grid.addEventListener('click', event => {
        const summary = event.target.closest?.('summary');
        const chosen = summary?.parentElement;
        if (!chosen?.matches('details.jacc-brand-group')) return;

        // Closing other groups before the browser toggles this summary
        // leaves the chosen brand open and keeps its links in place.
        grid.querySelectorAll('details.jacc-brand-group[open]').forEach(group => {
          if (group !== chosen) group.open = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installExclusiveBrands, { once: true });
  } else {
    installExclusiveBrands();
  }
  document.addEventListener('shopify:section:load', installExclusiveBrands);
})();
/*
 * JACC Our Brands: let the two desktop columns flow independently.
 *
 * BACKUP THEME: Assets > jacc-compact-header.js
 * Paste this ENTIRE block at the VERY BOTTOM, after the existing
 * "one open at a time" add-on. Keep all the code already in that file.
 * Do not paste into CSS or replace the header script.
 *
 * Brands A-H appear in the left column; K-W appear in the right column.
 * Links still expand directly below each brand. Mobile uses its own menu.
 */
(() => {
  const styleId = 'jacc-independent-brand-columns-style';

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media (min-width: 1150px) {
        .jacc-compact-header .jacc-brands-grid.jacc-independent-brand-columns > li.jacc-brand-column {
          min-width: 0;
          padding: 0;
          border: 0;
        }

        .jacc-compact-header .jacc-brands-grid.jacc-independent-brand-columns > li.jacc-brand-column > ul {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .jacc-compact-header .jacc-brands-grid.jacc-independent-brand-columns > li.jacc-brand-column > ul > li {
          border-bottom: 1px solid var(--jacc-line);
        }
      }
    `;
    document.head.append(style);
  }

  function installIndependentBrandColumns() {
    document.querySelectorAll('jacc-compact-header ul.jacc-brands-grid').forEach(grid => {
      if (grid.classList.contains('jacc-independent-brand-columns')) return;

      const brandRows = Array.from(grid.children);
      if (brandRows.length < 2 || brandRows.some(row =>
        row.tagName !== 'LI' || !row.querySelector(':scope > details.jacc-brand-group')
      )) return;

      const midpoint = Math.ceil(brandRows.length / 2);

      function makeColumn(rows) {
        const column = document.createElement('li');
        column.className = 'jacc-brand-column';
        column.setAttribute('role', 'presentation');

        const list = document.createElement('ul');
        list.className = 'unstyled-list';
        list.setAttribute('role', 'list');
        rows.forEach(row => list.append(row));
        column.append(list);
        return column;
      }

      // Move the ORIGINAL rows; the existing one-open listener remains on grid.
      grid.append(
        makeColumn(brandRows.slice(0, midpoint)),
        makeColumn(brandRows.slice(midpoint))
      );
      grid.setAttribute('role', 'presentation');
      grid.classList.add('jacc-independent-brand-columns');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installIndependentBrandColumns, { once: true });
  } else {
    installIndependentBrandColumns();
  }
  document.addEventListener('shopify:section:load', installIndependentBrandColumns);
})();
/*
 * JACC desktop Our Brands: keep the dropdown open while switching from a
 * long brand to a shorter one below it.
 *
 * BACKUP THEME: Assets > jacc-compact-header.js
 * Paste this ENTIRE block at the VERY BOTTOM, after BOTH existing Our Brands
 * add-ons (one-open-at-a-time and independent columns). Keep all prior code.
 * This goes in the JS file; do not replace the file or edit CSS.
 */
(() => {
  function installBrandSwitchHoverHold() {
    document.querySelectorAll('jacc-compact-header .jacc-brands-grid.jacc-independent-brand-columns').forEach(grid => {
      if (grid.dataset.jaccHoverSwitchHold === 'true') return;

      const menu = grid.closest('.jacc-brands-menu');
      const outerDetails = grid.closest('.jacc-brands-item')?.querySelector(':scope > dropdown-menu-disclosure > details');
      if (!menu || !outerDetails) return;

      let held = false;
      let previousInlineMinHeight = '';
      let switchNumber = 0;

      function releaseHeight() {
        if (!held) return;
        menu.style.minHeight = previousInlineMinHeight;
        held = false;
        previousInlineMinHeight = '';
      }

      function pointerIsOverBrand(x, y) {
        const hit = document.elementFromPoint(x, y);
        const group = hit?.closest?.('details.jacc-brand-group');
        return !!group && grid.contains(group);
      }

      // Capture runs BEFORE the existing one-open handler closes the old brand.
      grid.addEventListener('click', event => {
        const summary = event.target.closest?.('summary');
        const selected = summary?.parentElement;
        if (!selected?.matches('details.jacc-brand-group') ||
            event.detail === 0 || event.pointerType === 'touch' ||
            !matchMedia('(min-width: 1150px) and (hover: hover) and (pointer: fine)').matches) return;

        const previous = grid.querySelector('details.jacc-brand-group[open]');
        if (!previous) return;

        if (!held) previousInlineMinHeight = menu.style.minHeight;
        held = true;
        const oldHeight = menu.getBoundingClientRect().height;
        const style = getComputedStyle(menu);
        const nonContentHeight = style.boxSizing === 'border-box' ? 0 :
          (parseFloat(style.paddingTop) || 0) +
          (parseFloat(style.paddingBottom) || 0) +
          (parseFloat(style.borderTopWidth) || 0) +
          (parseFloat(style.borderBottomWidth) || 0);
        menu.style.minHeight = `${Math.max(0, oldHeight - nonContentHeight)}px`;

        const x = event.clientX;
        const y = event.clientY;
        const thisSwitch = ++switchNumber;
        requestAnimationFrame(() => {
          if (!held || thisSwitch !== switchNumber) return;
          if (!outerDetails.open || pointerIsOverBrand(x, y)) releaseHeight();
        });
      }, true);

      // Keep the old hit area only until the pointer reaches a real brand.
      menu.addEventListener('pointermove', event => {
        if (held && pointerIsOverBrand(event.clientX, event.clientY)) releaseHeight();
      });
      menu.addEventListener('pointerleave', releaseHeight);
      outerDetails.addEventListener('toggle', () => {
        if (!outerDetails.open) releaseHeight();
      });

      grid.dataset.jaccHoverSwitchHold = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installBrandSwitchHoverHold, { once: true });
  } else {
    installBrandSwitchHoverHold();
  }
  document.addEventListener('shopify:section:load', installBrandSwitchHoverHold);
})();




/* Reveal the station clock once at the top of each homepage visit. */
(() => {
  function installStationClock() {
    const clock = document.querySelector('.jacc-station-clock');
    const header = document.querySelector('jacc-compact-header .header');
    if (!clock || !header || clock.dataset.jaccInstalled) return;
    clock.dataset.jaccInstalled = 'true';
    const setTop = () => {
      document.documentElement.style.setProperty('--jacc-station-top', `${Math.max(0, header.getBoundingClientRect().bottom + 7)}px`);
    };
    setTop();
    if (matchMedia('(min-width: 1150px)').matches && window.scrollY < 40) {
      requestAnimationFrame(() => requestAnimationFrame(() => document.body.classList.add('jacc-clock-revealed')));
    }
    const retract = () => {
      if (window.scrollY > 65) {
        document.body.classList.remove('jacc-clock-revealed');
        window.removeEventListener('scroll', retract);
      }
    };
    window.addEventListener('scroll', retract, { passive:true });
    window.addEventListener('resize', () => {
      if (!matchMedia('(min-width: 1150px)').matches) document.body.classList.remove('jacc-clock-revealed');
      setTop();
    }, { passive:true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installStationClock, { once:true });
  else installStationClock();
  document.addEventListener('shopify:section:load', installStationClock);
})();
